"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const Checkbox = (props) => {
    const { disabled = false, label, checked, size = "medium", onChange, ...rest } = props;
    return (react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { disabled: disabled, checked: checked, size: size, onChange: onChange, ...rest }), label: label }));
};
exports.default = Checkbox;
